import frame from '@wwe-portal/ui/public/assets/images/roster/roster-avatar-frame.svg';
import avatarMask from '@wwe-portal/ui/public/assets/images/roster/roaster-avatar-mask.svg';
import React, { FC } from 'react';

import { TalentBadge } from './roster-card/power-badge';
import { RosterTier, RosterTierSkeleton } from './roster-card/roster-tier';
import { AutofitRosterStar } from './roster-star/autofit-roster-star';
import { IcoMoonIcon } from '@wwe-portal/ui/components/icons';
import { AspectRatio } from '@wwe-portal/ui/components/aspect-ratio';
import { RosterStarData } from './roster-star/roaster-star';
import { Skeleton } from '@wwe-portal/ui/components/skeleton';

const Layout: FC<{
  content: React.ReactNode;
  tier: React.ReactNode;
}> = ({ content, tier }) => {
  return (
    <div>
      <AspectRatio ratio={1}>{content}</AspectRatio>
      {tier}
    </div>
  );
};

export interface RosterAvatarProps {
  src?: string;
  imageElement?: React.ReactNode;
  tier?: string;
  power?: number;
  star?: RosterStarData;
  notOwned?: boolean;
}

export const RosterAvatar: FC<RosterAvatarProps> = ({
  src,
  imageElement,
  tier,
  power,
  star,
  notOwned,
}) => {
  return (
    <Layout
      tier={tier ? <RosterTier tier={tier} size="short" /> : null}
      content={
        <>
          <div
            className="absolute inset-0 h-full w-full"
            style={{
              maskImage: `url(${avatarMask})`,
              maskRepeat: 'no-repeat',
              maskSize: '95%',
              maskPosition: 'center',
            }}
          >
            <div className="bg-back400 absolute inset-0 h-full w-full" />
            {imageElement ??
              (src ? (
                <img
                  className="absolute inset-0 h-full w-full"
                  src={src}
                  alt="avatar mask"
                />
              ) : null)}
          </div>
          <img
            src={frame}
            className="drop-shadow-fx absolute inset-0 h-full w-full"
          />
          {power && (
            <div className="absolute right-1 top-0 -translate-y-1">
              <TalentBadge value={power} direction="down" size="sm" />
            </div>
          )}
          {star && (
            <div className="absolute inset-x-0 bottom-1">
              <AutofitRosterStar
                rate={star.rate}
                hollowStar={star.hollowStar}
                level={star.level}
                size={20}
                className="gap-0"
                gap={0}
                fullStarSize={28}
              />
            </div>
          )}
          {notOwned && (
            <div className="absolute bottom-1 left-1 flex h-5 w-5 items-center justify-center rounded-full bg-red-500">
              <IcoMoonIcon className="h-3 w-3 text-white" iconName="crown-2" />
            </div>
          )}
        </>
      }
    />
  );
};

export const RosterAvatarSkeleton: FC = () => {
  return (
    <Layout
      tier={<RosterTierSkeleton size="short" />}
      content={<Skeleton className="h-full w-full" />}
    />
  );
};
